var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.value,
        "overlay-color": "#000",
        "overlay-opacity": "0.66",
        persistent: true,
        "max-width": 600
      },
      on: { input: _vm.handleDialogInput }
    },
    [
      _c(
        "v-card",
        { staticClass: "dialog-card" },
        [
          _c(
            "v-card-title",
            { staticClass: "d-flex justify-space-between dialog-title-close" },
            [
              _vm._v(" Nahrať dokument "),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.closeDialog } },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c("v-combobox", {
                staticClass: "dynamic-input-control",
                attrs: {
                  items: _vm.typyDokumentovItems,
                  disabled: _vm.defaultTypDokumentuId != null,
                  label: "Typ dokumentu",
                  "item-text": "nazov",
                  outlined: "",
                  "return-object": ""
                },
                model: {
                  value: _vm.typDokumentuSelected,
                  callback: function($$v) {
                    _vm.typDokumentuSelected = $$v
                  },
                  expression: "typDokumentuSelected"
                }
              }),
              _c("v-textarea", {
                staticClass: "dynamic-input-control",
                attrs: {
                  name: "textareaPoznamka",
                  filled: "",
                  label: "Poznámka",
                  "auto-grow": "",
                  "no-resize": "",
                  rows: "3",
                  outlined: ""
                },
                model: {
                  value: _vm.poznamka,
                  callback: function($$v) {
                    _vm.poznamka = $$v
                  },
                  expression: "poznamka"
                }
              }),
              _c("upload-area", { ref: "refuploadarea" })
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "btn-secondary ml-5",
                  on: { click: _vm.closeDialog }
                },
                [_vm._v(" Späť ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "btn-primary",
                  attrs: { disabled: _vm.uloadujemData },
                  on: {
                    click: function($event) {
                      return _vm.dmsSave()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-upload-outline")
                  ]),
                  _vm._v(" Nahrať ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }